export const getUrl = (name) => {
  switch (name) {
    default:
      throw new Error(`not yet supported: ${name}`)
  }
}
